import { formatCompass16 } from './format.ts';

const COMPASS_TICKS = Array.from({ length: 16 }, (_, i) => i * 22.5);

export interface WindCompassRoseProps {
  deg: number;
  onChange: (deg: number) => void;
}

/** Small 16-point clickable compass rose for the direction the wind blows from. Shared by the
 * timeline editor (per-storm wind) and the simple conditions panel (main storm's wind). */
export function WindCompassRose({ deg, onChange }: WindCompassRoseProps) {
  const activeIdx = ((Math.round(deg / 22.5) % 16) + 16) % 16;
  return (
    <div class="wind-rose-dial">
      {COMPASS_TICKS.map((t, i) => (
        <div key={t} class="wind-rose-tick-wrap" style={{ transform: `rotate(${t}deg)` }}>
          <button
            type="button"
            class={'wind-rose-tick' + (i === activeIdx ? ' active' : '')}
            aria-label={`Wind from ${formatCompass16(t)}`}
            onClick={() => onChange(t)}
          />
        </div>
      ))}
      <div class="wind-rose-arrow" style={{ transform: `rotate(${deg}deg)` }} />
      <div class="wind-rose-center">N</div>
    </div>
  );
}
